import React from 'react';
import PropTypes from 'prop-types';
import aefSources from '../../../data/aef_sources.json';
import GdfContent from './GlobalDeforestationFrontsContent';

const Metadata = props => {
  const { name, description, source, sourceurl, fullcitation } = props;

  const metadata_class = name && name.toLowerCase().indexOf('global deforestation fronts') !== -1 ? 'Metadata gdf' : 'Metadata';

  function formatSources() {
    if (name && name.toLowerCase().indexOf('ancient') !== -1) {
      return aefSources.map(item => (
        <p className="source">
          {item.source}{' '}
          <a target="_blank" rel="noopener noreferrer" href={item.sourceurl}>
            {item.sourceurl}
          </a>
        </p>
      ));
    }
    return (
      <p className="source">
        {source || 'no source provided'}{' '}
        <a target="_blank" rel="noopener noreferrer" href={sourceurl}>
          {sourceurl}
        </a>
      </p>
    );
  }

  function addAdditionalDescriptionContent() {
    if (name && name.toLowerCase().indexOf('global deforestation fronts') !== -1) {
      return (
        <GdfContent />
      );
    }
    return ('');
  }

  return (
    <div className={metadata_class}>
      <h1>{name}</h1>
      <h4>Description</h4>
      <p>{description || ''}</p>
      {addAdditionalDescriptionContent()}
      <hr />
      <h4>Source</h4>
      {formatSources()}
      <hr />
      <p>{fullcitation || ''}</p>
    </div>
  );
};

Metadata.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  source: PropTypes.string,
  sourceurl: PropTypes.string,
  fullcitation: PropTypes.string,
  closeLightbox: PropTypes.func.isRequired,
};

Metadata.defaultProps = {
  description: 'no description provided',
  source: 'no source provided',
  sourceurl: '',
  fullcitation: 'no citation provided',
};

export default Metadata;



// WEBPACK FOOTER //
// ./src/components/Lightbox/Metadata.jsx